import { getClient, version } from "./storyblok-client";

/**
 * Fetch a single Storyblok story by slug.
 */
export async function getStory(
  slug: string,
  resolveRelations: string[] = [],
  resolveLinks: "url" | "story" | null = null
) {
  const storyblokApi = getClient();

  try {
    const timestamp = Date.now();
    const { data } = await storyblokApi.get(
      `cdn/stories/${slug}`,
      {
        version,
        resolve_relations:
          resolveRelations.length > 0 ? resolveRelations.join(",") : undefined,
        resolve_links: resolveLinks ?? undefined,
        cv: timestamp,
      },
      {
        next: { revalidate: 0 }
      }
    );

    return data?.story || null;
  } catch (error) {
    if (error && typeof error === 'object' && 'status' in error && error.status === 404) {
      throw new Error('STORY_NOT_FOUND');
    }
    return null;
  }
}